/* __next_internal_client_entry_do_not_use__ FormField auto */ import styled from "styled-components";
/**
 * @trackcomponent
 */ export var FormField = styled.div.withConfig({
    componentId: "sc-3f571ad1-0"
})([
    "grid-area:",
    ";"
], function(props) {
    return props.$name;
});
